var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11.997274,277.64328 c -0.587861,-0.0152 -1.138303,0.28664 -1.441255,0.79065 l -9.62111845,16.03726 c -0.65391929,1.08986 0.13306865,2.47607 1.40404855,2.47272 l 19.3104489,-0.0667 c 1.271047,-0.004 2.051157,-1.39422 1.39113,-2.48047 L 13.35068,278.42821 c -0.288202,-0.47496 -0.798035,-0.77058 -1.353406,-0.78497 z m -0.05839,6.59753 a 1.0326033,1.0326033 0 0 1 1.046448,1.04697 v 3.14037 a 1.0326033,1.0326033 0 1 1 -2.063957,0 v -3.14037 a 1.0326033,1.0326033 0 0 1 1.017509,-1.04697 z m -0.453202,7.31222 h 0.962732 a 0.65006497,0.65006497 0 0 1 0.648539,0.64853 v 1.0139 a 0.65006497,0.65006497 0 0 1 -0.648539,0.65009 h -0.962732 a 0.65006497,0.65006497 0 0 1 -0.64854,-0.65009 v -1.0139 a 0.65006497,0.65006497 0 0 1 0.64854,-0.64853 z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.b94fe5d3.svg";
export { ForwardRef as ReactComponent };